import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Section, SectionHeading } from '../components/Section';
import { Reveal } from '../components/Reveal';
import { ClosingCTA } from '../components/ClosingCTA';
import { founder, deskFunctions } from '../data/team';
const facts = [{
  label: 'Founded',
  value: '2026, Bengaluru'
}, {
  label: 'Founder',
  value: 'Prashanth Sekhar'
}, {
  label: 'Registration',
  value: 'SEBI RIA INA200016412'
}, {
  label: 'Experience',
  value: '15+ yrs, public & private markets'
}, {
  label: 'Fee model',
  value: 'Fee-only, no commissions'
}];
export function About() {
  return <main data-id="element-230" data-mp="2s9bqq80n0qbi">
      <PageHeader eyebrow="About" title="Founded in 2026, so that good advice stops depending on your pin code." lede="MeraBucket was founded in Bengaluru in 2026 by Prashanth Sekhar — a SEBI Registered Investment Adviser with more than fifteen years across public and private markets — and opened its first branch in Chennai the same year." data-id="element-231" data-mp="2s9v7vmigraoh" />

      <Section data-id="element-232" data-mp="1uhigjk3kou8a">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-14" data-id="element-233" data-mp="1uh0ajvr3z1n6">
          <div className="lg:col-span-7" data-id="element-234" data-mp="1pioz5gl60j2u">
            <span className="font-sans text-overline font-semibold uppercase text-gold-dark" data-id="element-235" data-mp="1pjqlwibjmu0e">
              The founding story
            </span>
            <div className="mt-6 max-w-prose space-y-5 text-[1.0625rem] leading-relaxed text-charcoal-600" data-id="element-236" data-mp="23g3t8ymd5f15">
              {founder.bio.map(paragraph => <p key={paragraph.slice(0, 32)} data-id="element-237" data-mp="2dfuox3mnu02t">{paragraph}</p>)}
              <p data-id="element-238" data-mp="2deb7vat6jkzz">
                The families we serve built their wealth in manufacturing, trade, healthcare,
                technology and professional practice. They are not short of people willing to advise
                them — they are short of anyone willing to be accountable: to consolidate every
                holding into one view, to say no to a fashionable product, and to sit down with three
                generations before succession becomes urgent.
              </p>
              <p data-id="element-239" data-mp="2r5y79jif59mz">
                So the firm is built the other way around. Research, diligence and reporting are
                centralised in Bengaluru, where the firm began. The relationship stays where the
                family is — starting with our first branch in Chennai, and by 2028 Pondicherry,
                Mangaluru, Madurai, Pune, Belgaum, Nashik and Indore.
              </p>
            </div>
          </div>

          <aside className="lg:col-span-5" data-id="element-240" data-mp="27le5be12698y">
            <img src={founder.portrait} alt={`${founder.name}, founder of MeraBucket, at his desk`} className="h-[24rem] w-full rounded-sm border border-line object-cover object-top shadow-card" data-id="element-241" data-mp="27kmaw6j76hk9" />
            <div className="mt-5" data-id="element-242" data-mp="2gmc3vgsq9ok5">
              <p className="font-serif text-xl text-charcoal" data-id="element-243" data-mp="2lkx43g7zc88l">{founder.name}</p>
              <p className="mt-1 text-sm text-gold-dark" data-id="element-244" data-mp="2lit253tn5jay">
                {founder.role} · {founder.location}
              </p>
              <p className="mt-1 text-xs uppercase tracking-wider text-charcoal-400" data-id="element-245" data-mp="r6mev6nh3c2a">
                {founder.credential}
              </p>
            </div>
            <dl className="mt-6 divide-y divide-line border-y border-line" data-id="element-246" data-mp="joy2raso1aes">
              {facts.map(row => <div key={row.label} className="flex items-baseline justify-between gap-6 py-3.5" data-id="element-247" data-mp="ev27ig3se1nb">
                  <dt className="text-xs uppercase tracking-wider text-charcoal-400" data-id="element-248" data-mp="9y3anpsqnglf">{row.label}</dt>
                  <dd className="text-right text-sm font-medium text-charcoal" data-id="element-249" data-mp="501rl4vbbh9y">{row.value}</dd>
                </div>)}
            </dl>
          </aside>
        </div>
      </Section>

      <Section tone="paper" data-id="element-250" data-mp="xo63i84h8ql3">
        <SectionHeading eyebrow="The central desk" title="What sits behind every recommendation your adviser makes." description="We are a young firm, so we describe this as functions rather than headcount. Each one is owned, documented, and applied the same way for every family." data-id="element-251" data-mp="xnxrsjk3brbh" />
        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-252" data-mp="3dfty3ww0q70q">
          {deskFunctions.map((item, index) => <Reveal as="li" key={item.title} delay={Math.min(index, 5) * 0.04} data-id="element-253" data-mp="39bdrftekyvkg" data-mpi={index}>
              <div className="flex h-full flex-col rounded-sm border border-line bg-cream p-6" data-id="element-254" data-mp="1137c5xwje2p8">
                <h3 className="font-serif text-h3 text-charcoal" data-id="element-255" data-mp="15vhaa17t292l">{item.title}</h3>
                <p className="mt-3 text-[0.925rem] leading-relaxed text-charcoal-600" data-id="element-256" data-mp="r6ktnfronnqd">
                  {item.detail}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </Section>

      <ClosingCTA eyebrow="Meet us" title="Ask us anything before you become a client." body="Including what we charge, how a new firm protects your interests, and which families we are not the right adviser for." data-id="element-257" data-mp="1jvi97b4if6ff" />
    </main>;
}